import axios from 'axios';
import config from '../apiConfig';

/**
 * Post message to eStoris
 * @param {object} log
 */
const logMessage = log => {
	const instance = axios.create(config);
	return instance.post('LogMessage', {
		message: log.message,
		stack: log.specific,
		level: log.level,
	});
};

// eslint-disable-next-line import/prefer-default-export
export { logMessage };
